import styles from "./Seventh.module.css";
import SubFooter from "../components/footer/SubFooter";

function Seventh() {
  const footerContent = [
    {
      title: "Approaches",
      content: [
        "Design thinking and agility(Scrum)",
        "UX and UI design",
        " DEVOPS",
        "software development process",
      ],
    },
    {
      title: "Applications",
      content: [
        "Visual Studio Code,",
        "Eclipse, Postman, Docker,",
        " Desktop, Git Bash,",
        "GitHub, Balsamiq, Figma,",
        "Enterprise Architect,",
        "Vmware Workstation,",
        "Kaggle, Unity.",
      ],
    },
    {
      title: "OS",
      content: [
        "Linux(Ubuntu, CentOS 7,",
        "Kali),Bash scripting",
        "Communication protocols (Telnet and SSH)",
        "processes management",
        "vi editor",
      ],
    },
    {
      title: "Hobbies",
      content: ["Jogging", "BodyBuilding", "Hiking", "Traveling"],
    },
  ];

  return (
    <div className={styles.footer}>
      <SubFooter subfooter={footerContent[0]} />
      <SubFooter subfooter={footerContent[1]} />
      <SubFooter subfooter={footerContent[2]} />
      <SubFooter subfooter={footerContent[3]} />
    </div>
  );
}
export default Seventh;
